<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IneKVH/images/bcover.jpg?1703000976033" alt="This image is the cover for the book Amigurumi Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amigurumi Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p>Do you love to decorate your home and make wonderful Christmas decorations for all your family and friends to enjoy? Then this is the book for you. It will delight and surprise with its fantastically cute, kawaii-style crocheted Christmas cuties. There are 20 great projects to make, including a wonderful Santa Claus accompanied by a lovely Mrs Claus; a cute penguin, polar bear and gingerbread man; Brussels sprouts, Christmas angel and even pigs in blankets! With a short techniques section at the beginning to explain the basics, these projects can be worked up quickly and easily using small amounts of yarn in your stash. You can even customize some of the projects if you wish and make Santa, the elf or the snowman's head into baubles with a short piece of yarn to hang them up. Whether you make these for your family or as gifts for friends, now is the time to pick up your hook and get crocheting amigurumi style!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah-Jane Hicks
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Search Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e1ec45b